"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.clearPersistedData = exports.savePersistedData = exports.getPersistedData = void 0;
var LoggerFactory_1 = require("../utils/LoggerFactory");
var PERSISTED_DATA_STORAGE_KEY = 'metrics_persisted_base_props';
var LOG = LoggerFactory_1.LoggerFactory.create('PageActionsStorage');
/**
 * Gets the persisted data that will be later included in every action tracked/measured
 * @returns
 */
var getPersistedData = function () {
    try {
        var storageData = sessionStorage.getItem(PERSISTED_DATA_STORAGE_KEY);
        var persistedData = storageData ? JSON.parse(storageData) : {};
        return persistedData;
    }
    catch (_) {
        // Only show warning if this is coming from the browser
        if (typeof window !== 'undefined') {
            LOG.warn('The user device does not support the local storage api. Consider passing the `getPersistedDataCallback` in order to persist base properties');
        }
        return undefined;
    }
};
exports.getPersistedData = getPersistedData;
/**
 * Saves the data in the user's device. This data later is read from storage and set as base props of every action
 * @param data
 */
var savePersistedData = function (data) {
    try {
        var persistedData = (0, exports.getPersistedData)();
        sessionStorage.setItem(PERSISTED_DATA_STORAGE_KEY, JSON.stringify(__assign(__assign({}, persistedData), data)));
    }
    catch (_) {
        // Only show warning if this is coming from the browser
        if (typeof window !== 'undefined') {
            LOG.warn('The user device does not support the local storage api. Consider passing the `setPersistedDataCallback` in order to persist base properties');
        }
    }
};
exports.savePersistedData = savePersistedData;
var clearPersistedData = function () {
    if (typeof window !== 'undefined') {
        sessionStorage.removeItem(PERSISTED_DATA_STORAGE_KEY);
        if (localStorage.getItem(PERSISTED_DATA_STORAGE_KEY)) {
            // Older version was using localStorage, so we need to remove it as well
            localStorage.removeItem(PERSISTED_DATA_STORAGE_KEY);
        }
    }
};
exports.clearPersistedData = clearPersistedData;
